// export const ENDPOINT = `http://192.168.1.149:3031/api/v1`; // LOCAL
// export const SOCKET_URL_ENDPOINT = `http://192.168.1.149:3031`; // LOCAL

// export const ENDPOINT = `https://api.enjoyfresh.com:3001/api/v1`; // LOCAL
// export const SOCKET_URL_ENDPOINT = `https://api.enjoyfresh.com:3001/`;

// export const ENDPOINT = `https://api.enjoyfresh.com:4001/api/v1`;
// export const SOCKET_URL_ENDPOINT = `https://api.enjoyfresh.com:4001/`; // TEST
// // TEST
export const ENDPOINT = `https://api.enjoyfresh.com/api/v1`;
export const SOCKET_URL_ENDPOINT = `https://api.enjoyfresh.com/`;

export const GET_USERS = `/admin/users/get`;
export const GET_FOOD_ITEMS = `/food/item/services/get/items`;
export const USER_ACTIVE_ORDERS = `/admin/get/:userId/user-orders`;
export const GET_SELLERS = `/admin/get/chef-restaurant`;
export const ADMIN_PAYMENTS = `/admin/payment/get`;
//export const GET_SELLERS = (sellerType) => `/food/seller/services/get/all/retaura
export const GET_CATEGORIES = `/food/item/services/get/categories`;
export const GET_CATEGORIES_ALL = `/admin/category/get`;
export const GET_SELLER_ALL = `/admin/get-sellers`;
export const GET_SUBCATEGORIES_ALL = `/common/sub-category/get`;
//export const GET_ORDERS = `/order/services/get/admin/orders`;
export const GET_ORDERS = `/admin/order/get`;
export const GET_SELLERS_ORDERS = `/admin/seller/orders/:seller_id`;

export const GET_SETTLEMETS_SELLER = `/admin/settlement/pending/sellers`;
export const GET_SETTLEMETS_HISTORY = `/admin/settlement/sellers/list/history`;
export const GET_SELLER_SETTLEMETS = `/admin/settlement/sellers/orders`;

export const GET_PAYMENTS_BY_CHEE = `/admin/seller/revenue-details`;
export const GET_DISHTAGS = `/tag/services/get/all`;
export const WALLET_PAYMENTS = `/payment/services/get/payments`;
export const USER_ORDERS_HISTORY = `/order/services/get/admin/orders/buyer`;
export const ADMIN_SETTLEMETS = `/settlements/services/get/seller/pending/settlements/summary/for/admin`;
export const SETTLEMENT_ENABLE_DISABLE = `/food/seller/services`;
export const DAY_WISE_SETTLEMETS = `/settlements/services/get/seller/`;
export const SELLER_WISE_SETTLEMETS = `/report/services/get/seller/wise/margins/for/admin`;
export const CONSOLIDATED_SETTLEMETS = `/report/services/get/consolidated/margins/for/admin`;

export const AWS_ACCESS_KEY = `AKIAXZGIOON3YPGWTSHL`;
export const AWS_SECRET_KEY = `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`;
export const BUCKET_NAME = `app.enjoyfresh.com`;
export const S3URL = `http://s3.amazonaws.com/app.enjoyfresh.com`;
export const REGION_NAME = `us-east-1`;
